var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormulas = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 20,
  x: 2.273,
  y: 2,
  stroke: "currentColor",
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "m12.416 5 .879-.879a3 3 0 0 1 4.242 0l2.829 2.829a3 3 0 0 1 0 4.242l-7.95 7.95"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M19.273 12a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-12"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.273,
  cy: 18,
  r: 1,
  fill: "currentColor"
})));
export default SvgFormulas;